import { render } from "./Champ_Date_Naissance.vue?vue&type=template&id=65b8f6f7"
import script from "./Champ_Date_Naissance.vue?vue&type=script&lang=js"
export * from "./Champ_Date_Naissance.vue?vue&type=script&lang=js"

import "./Champ_Date_Naissance.vue?vue&type=style&index=0&id=65b8f6f7&lang=scss"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__